import { ProjectMilestone } from '../../../domain/projectMilestones/projectMilestone';
import { ProjectMilestoneList } from '../../../domain/projectMilestones/projectMilestoneList';
import { ProjectMilestoneListModel } from '../../../domain/projectMilestones/projectMilestoneListModel';
import { ProjectMilestoneListModelDTO } from '../../http/dtos/projectMilestones/ProjectMilestoneListModelDTO';
import { ProjectMilestoneDTO } from '../../http/dtos/projectMilestones/projectMilestoneDTO';
import { ProjectMilestoneListDTO } from '../../http/dtos/projectMilestones/projectMilestoneListDTO';

const getProjectMilestoneListAdapter = (
    responseAPI: ProjectMilestoneListDTO[]
): ProjectMilestoneList[] => {
    return responseAPI
        ? responseAPI.map((milestone) => {
              return {
                  id: milestone.id,
                  name: milestone.name,
                  ordinality: milestone.ordinality,
                  typeProject: milestone.typeProject,
                  plannedPercentage: milestone.plannedPercentage,
                  percentageRealized: milestone.percentageRealized,
              };
          })
        : [];
};

const getProjectMilestoneListTableAdapter = (
    responseAPI: ProjectMilestoneListModelDTO[]
): ProjectMilestoneListModel[] => {
    return responseAPI
        ? responseAPI.map((milestone) => {
              return {
                  id: milestone.id,
                  name: milestone.name,
                  plannedPercentage: milestone.plannedPercentage,
                  percentageRealized: milestone.percentageRealized,
                  weight: milestone.weight,
                  tasks: milestone.tasks ?? [],
              };
          })
        : [];
};

const getProjectMilestoneAdapter = (
    responseAPI: ProjectMilestoneDTO
): ProjectMilestone => {
    return {
        id: responseAPI.id,
        name: responseAPI.name,
        ordinality: responseAPI.ordinality,
        typeProject: responseAPI.typeProject,
        milestoneProjectRequest: responseAPI.milestoneProjectRequest,
    };
};

export const ProjectMilestoneAdapter = {
    getProjectMilestoneListAdapter,
    getProjectMilestoneAdapter,
    getProjectMilestoneListTableAdapter,
};
